module.exports = __webpack_public_path__ + "0c3f81cdf55721e3a6811e9d0df999ba.gif";